import { headingPrimary } from "@/constants";
import { Action, UserJourney } from "@/context/AnalyticsProvider";
import Image from "next/image";
import { CarouselButtons } from "./CarouselButtons";
import { useHeroCarousel } from "./useHeroCarousel";

export const CarouselContent = () => {
  const { currentSlide, currentIndex, router, track } = useHeroCarousel();

  const handleClick = () => {
    track({
      action: Action.PRESSED,
      extras: {
        slideId: currentSlide.route,
        slideTitle: currentSlide.description,
        ctaText:
          typeof currentSlide.ctaText === "string"
            ? currentSlide.ctaText
            : "ButtonCTAContent",
        route: currentSlide.route,
        slideIndex: currentIndex,
        control:
          typeof currentSlide.ctaText === "string"
            ? currentSlide.ctaText
            : "CarouselButton",
        controlType: "Button",
        screen: "HeroCarousel",
        userJourney: UserJourney.CAROUSEL,
      },
    });

    if (currentSlide.route) {
      router.push(currentSlide.route);
    }
  };

  return (
    <div className="flex relative items-center max-w-2xl md:items-start flex-col md:pl-2 gap-4">
      <div className="h-24 w-full md:h-32 flex justify-center items-end md:justify-start overflow-hidden">
        {currentSlide.logoUrl && (
          <Image
            src={currentSlide.logoUrl}
            alt={`${currentSlide.logoUrl} logo`}
            width={600}
            height={200}
            className="cursor-pointer object-contain max-h-full"
            onClick={handleClick}
          />
        )}
      </div>

      <div className="h-20 w-full flex items-center md:items-start flex-col justify-start">
        {currentSlide.title && (
          <p
            className={`${headingPrimary.className} text-2xl md:text-3xl font-bold whitespace-pre-line text-center md:text-left`}
          >
            {currentSlide.title.replace(/ \| /g, "\n").replace(/\\n/g, "\n")}
          </p>
        )}
      </div>

      <div className="hidden md:flex h-6 w-full flex-col items-start justify-start">
        {currentSlide.description && (
          <p
            className={`${headingPrimary.className} text-lg font-medium whitespace-pre-line text-left text-white/90 max-w-md`}
          >
            {currentSlide.description
              .replace(/ \| /g, "\n")
              .replace(/\\n/g, "\n")}
          </p>
        )}
      </div>
      <CarouselButtons />
    </div>
  );
};
